import React from "react";
import { Grid, Container, Stack } from "@mui/material";

// Components
import MKBox from "components/MKBox";
import MKButton from "components/MKButton";
import MKTypography from "components/MKTypography";
import ThreeStackCard from "styles/components/threeStackCard";
import { ImageContainer } from "styles/components/imageContainer";

// Styles
import { StyledSectionContainer } from "styles/components/SectionContainer/index.styles";
import { Link } from "react-router-dom";
import Banner from "components/Banner/banner";
import NumberIcon from "components/NumberIcon/numberIcon";
import useMediaQueries from "utils/mediaQueries.utils";
import { StyledButtonContainer } from "index.styles";
import { Phone } from "@mui/icons-material";

const threeStackCardV2Styles = {
  position: "relative",
};
const iconMapping = {
  PhoneIcon: Phone,
};

const StartYourJourney = ({ ...props }) => {
  const { cards, cta, cardType, secondaryCta } = props;
  const { isLg, isMd } = useMediaQueries();

  // Calculate responsive grid sizes based on number of cards
  const getGridSizes = (cardCount) => {
    if (cardCount <= 1) {
      return { xs: 12, sm: 12, md: 12, lg: 12 };
    } else if (cardCount === 2) {
      return { xs: 12, sm: 12, md: 6, lg: 6 };
    } else if (cardCount === 3) {
      return { xs: 12, sm: 6, md: 4, lg: 4 };
    } else if (cardCount === 4) {
      return { xs: 12, sm: 6, md: 6, lg: 3 };
    } else {
      // 5+ cards: allow wrapping
      return { xs: 12, sm: 6, md: 4, lg: 2 };
    }
  };

  const gridSizes = getGridSizes(cards?.length || 3);

  const ButtonContainer = () => {
    const { text, link, external, ariaLabel } = cta;
    const { text: secondaryText, link: secondaryLink, external: secondaryExternal, ariaLabel: secondaryAriaLabel } = secondaryCta || {};
    return (
      <StyledButtonContainer sx={{ display: "flex", gap: "1rem", flexDirection: isMd ? "row" : "column", justifyContent: "center" }}>
        <MKButton
          color="secondary"
          size="large"
          fullWidth={isMd ? false : true}
          sx={{ minWidth: isMd ? "160px" : "auto" }}
          component={Link}
          to={link}
          aria-label={ariaLabel && ariaLabel}
          target={external ? "_blank" : undefined}
          rel={external ? "noopener noreferrer" : undefined}
        >
          {text}
        </MKButton>
        {secondaryCta && (
          <MKButton
            color="secondary"
            variant="outlined"
            size="large"
            fullWidth={isMd ? false : true}
            sx={{ minWidth: isMd ? "160px" : "auto" }}
            component={Link}
            to={secondaryLink}
            aria-label={secondaryAriaLabel && secondaryAriaLabel}
            target={secondaryExternal ? "_blank" : undefined}
            rel={secondaryExternal ? "noopener noreferrer" : undefined}
            startIcon={
              secondaryCta.startIcon &&
              iconMapping[secondaryCta.startIcon.iconName] &&
              React.createElement(iconMapping[secondaryCta.startIcon.iconName], { sx: { fontSize: "1.25rem", color: "inherit !important" } })
            }
          >
            {secondaryText}
          </MKButton>
        )}
      </StyledButtonContainer>
    );
  };

  const InfoCards = () => {
    const topComponent = (item) => {
      return (
        <Container sx={{ padding: "0rem !important", margin: "0rem !important" }}>
          <ImageContainer image={item.imageUrl} alt={item.alt} />
        </Container>
      );
    };

    const middleComponent = (item, index) => {
      return (
        <MKBox sx={{ margin: "0.5rem" }}>
          {cardType === "threeStackCard-v2" ? (
            <Stack direction="row" alignItems="center" mt={2}>
              <MKTypography variant="h6" component="span">
                <NumberIcon
                  customIconSize={45}
                  number={index + 1}
                  dark={true}
                  sx={{ marginRight: "0rem !important", position: "absolute", top: "8px", left: "8px" }}
                />
              </MKTypography>
              <MKTypography variant="h6" component="h3">
                <>{item.description} </>
              </MKTypography>
            </Stack>
          ) : (
            <>
              <MKTypography variant="h4" element="h4" sx={{ fontSize: "4rem", textAlign: "center" }}>
                <>{index + 1}</>
              </MKTypography>
            </>
          )}
        </MKBox>
      );
    };

    const bottomComponent = (item) => {
      return (
        <MKBox sx={{ margin: "0.5rem" }}>
          <MKTypography
            element={cardType === "threeStackCard-v2" ? "p" : "h4"}
            variant={cardType === "threeStackCard-v2" ? (isLg ? "body1" : "body2") : "h4"}
          >
            {cardType === "threeStackCard-v2" ? item.paragraph : item.description}
          </MKTypography>
        </MKBox>
      );
    };

    return (
      <Grid
        container
        spacing={3}
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
        }}
      >
        {cards.map((card, index) => (
          <Grid item {...gridSizes} key={index} sx={{ minWidth: "200px !important" }}>
            <ThreeStackCard
              cssProps={cardType === "threeStackCard-v2" ? { ...threeStackCardV2Styles } : {}}
              topComponent={topComponent(card)}
              midComponent={middleComponent(card, index)}
              botComponent={bottomComponent(card)}
            />
          </Grid>
        ))}
      </Grid>
    );
  };

  return (
    <>
      <Banner content={props} />
      <StyledSectionContainer id="ketamine-therapist-hub-start-your-journey-cards-container">
        <InfoCards />
        <ButtonContainer />
      </StyledSectionContainer>
    </>
  );
};

export default StartYourJourney;
